import { render, staticRenderFns } from "./InputDamageType.vue?vue&type=template&id=166f2624&scoped=true&"
import script from "./InputDamageType.vue?vue&type=script&lang=js&"
export * from "./InputDamageType.vue?vue&type=script&lang=js&"
import style0 from "./InputDamageType.vue?vue&type=style&index=0&id=166f2624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f2624",
  null
  
)

export default component.exports